<template>
  <div class="servidores-olt-placas">
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="65">Slot</th>
              <th>Tipo placa</th>
              <th>Tipo config / hardware</th>
              <th>Portas</th>
              <th>Versão hardware</th>
              <th>Versão software</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="placa in placas" :key="placa.id" :class="cssRowPlaca(placa)" v-on:click="handleEditaPlacaOlt(placa)">
                <td scope="row">
                  {{placa.slot}}
                </td>
                <td>{{placa.tipo}}</td>
                <td>{{placa.tipo_config}} / {{placa.tipo_hardware}}</td>
                <td>{{placa.portas}}</td>
                <td>{{placa.versao_hardware}}</td>
                <td>{{placa.versao_software}}</td>
                <td>{{placa.status_str}}</td>
              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
    </div>
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ServidoresOLTPlacas',

  components: {
    Paginador,
  },

  data() {
    return {
      oltID: undefined,
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      placas: [],
    }
  },

  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/servidores/olt/${this.oltID}/placas?${this.paginador.requestParams}&orderBy[slot]=ASC`).then(res => {
        loading(false);
        this.placas = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    placaValida(placa) {
      const homologados = ['tpUplink'];

      switch (true) {
        case (!placa || !homologados.includes(placa.tipo) || placa.status_sgm !== 'ssPronta'):
          return false;

        default:
          return true;
      }
    },

    cssRowPlaca(placa) {
      if (!this.placaValida(placa)) {
        return ['text-muted-2'];
      }

      return ['text-info', 'cursor-pointer'];
    },

    handleEditaPlacaOlt(placa) {
      if (!this.placaValida(placa)) {
        return;
      }

      const oltID = this.oltID;
      const placaID = placa.id;

      this.$router.push({ path: `/configuracoes/servidores/olts/${oltID}/placa-uplink/${placaID}` });
    },
  },

  created() {
    const oltID = +this.$route.params.oltID;

    if (!oltID) {
      this.$router.push({ path: `/configuracoes/servidores` });
      return;
    }

    this.oltID = oltID;

    this.handlePesquisa();
  },
}
</script>
